import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { ApisInfo } from '@/types';
import { fetchApisInfoActions } from '@/redux/actions/service-directory/api-info';
import { ApiInfoInstance } from '@/services/service-directory/api-info';

export function* fetchApisInfoSaga(action: ActionType<typeof fetchApisInfoActions.request>) {
  try {
    const { entityId } = action.payload;
    const apisInfo = yield call(ApiInfoInstance.fetchApisInfo, entityId);
    const { groups, apis } = normalizeApiDocs(apisInfo);

    yield put(fetchApisInfoActions.success(groups, apis));
  } catch (error) {
    yield put(fetchApisInfoActions.failure(error));
  }
}

export default function* root() {
  yield all([takeLatest(fetchApisInfoActions.request.type, fetchApisInfoSaga)]);
}

const normalizeApiDocs = (apisInfo: ApisInfo) => {
  const groups = new Set<string>();

  apisInfo.forEach((doc) => {
    groups.add(doc.groupName);
  });

  return {
    groups: Array.from(groups),
    apis: apisInfo,
  };
};
